<template>
<div class="wl-n-metarial-wrapper">
    <div class="new-center-content clearfix">
        <div class="new-center-top fl">
            <div class="new-top-nav" :style="{background:'url('+imgs+')'}">
                <h1 class="new-top-title fl">S</h1>
                <div class="fl" style="padding-left:4px;">
                    <p class="new-top-navtitle">学习中心</p>
                    <p class="new-top-ews">TUDY</p>
                </div>
            </div>
            <div class="new-center-tab">
                <div class="new-center-dynamic" @click="toMetarial">
                    教材中心
                    <span class="wl-icon wl-icon-xiangyou fr"></span>
                </div>
                <div class="new-center-dynamic class-back" @click="toVideoList('')">
                    串讲视频
                    <span class="wl-icon wl-icon-xiangyou fr"></span>
                </div>
                <div class="new-center-dynamic c-video-change-btn" v-for="(item,index) in videoTypeList" :key="index" @click="toVideoList(item.value)" :class="{'class-back-item' : videoTypeId == item.value}">
                    {{item.label}}
                    <span class="wl-icon wl-icon-xiangyou fr"></span>
                </div>
                <a class="link-child-li" href="http://ykt.clppx.org.cn/wlykt/home" target="_blank">
                    <div class="new-center-dynamic">
                        中物联云课堂
                        <span class="wl-icon wl-icon-xiangyou fr"></span>
                    </div>
                </a>
                <a class="link-child-li" href="http://test.clppx.org.cn/login" target="_blank">
                    <div class="new-center-dynamic">
                        模拟练习平台
                        <span class="wl-icon wl-icon-xiangyou fr"></span>
                    </div>
                </a>
            </div>
        </div>
        <div class="fr left-main-content">
            <div class="new-center-listnav">
                <h2>串讲视频</h2>
                <div class="new-center-path">
                    <div class="crumbs-text">
                        <i class="wl-icon-zhuye1"></i>
                        <span>当前位置：</span>
                        <span @click="goHome" style="cursor: pointer;">网站首页</span>
                        <span>></span>
                        <span>串讲视频</span>
                    </div>
                </div>
            </div>
            <div class="cj-video-main-con">
                <div class="choose-publishBooks-time clearfix">
                    <span class="fl change-year-btn change-label">综合排序：</span>
                    <span class="fl change-year-btn" :class="{'tabActive' : orderNum == 1}" @click="changeData(1)">发布时间</span>
                    <span class="fl change-year-btn" :class="{'tabActive' : orderNum == 2}" @click="changeData(2)">观看次数</span>
                    <el-input placeholder="请输入视频名称" v-model="searchVideoName" class="fr search-video-input">
                        <el-button slot="append" icon="el-icon-search" @click="searchVideo"></el-button>
                    </el-input>
                </div>
                <div class="choose-publishBooks-time cerfitycate-type-con clearfix">
                    <span class="fl change-year-btn change-label">证书类型：</span>
                    <span class="fl change-year-btn" v-for="item in certifycateList" :key="item.id" :class="{'tabActive' : certifycateId == item.id}" @click="changeCertifyType(item.id)">{{item.CertificateName}}</span>
                </div>
                <div class="metarial-list-con clearfix">
                    <div class="fl video-list-item" v-for="(item,index) in videoList" :key="index">
                        <router-link :to="{name:'videoDetail',params:{videoId:item.id}}" target="_blank">
                            <div class="video-cover-con">
                                <img :src="item.docUrl+'?x-oss-process=video/snapshot,t_10000,f_jpg,w_329,h_160'" alt v-if="item.docUrl" />
                                <img :src="cover" alt v-else />
                                <div class="video-time-con">{{item.docTimeLenght}}</div>
                            </div>
                            <div class="video-intro-con">
                                <p class="p-video-name">{{item.videoTitle}}</p>
                                <div class="clearfix video-time-con">
                                    <span class="fl">
                                        <i class="wl-icon-shijian"></i>
                                        {{item.dateCreated}}
                                    </span>
                                    <span class="fr">
                                        <i class="wl-icon-chakan"></i>
                                        {{item.viewCount}}
                                    </span>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <img :src="nodataImg" alt v-show="videoList.length==0" style="margin:0px auto 0px;display: block;" />
                <div class="el-block-pagination">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-sizes="[10, 20, 40, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
                </div>
            </div>
        </div>
    </div>
    <div class="ph-new-center-content">
        <div class="crumbs-text">
            <div style="padding:0 20px;">
                <i class="wl-icon-zhuye1"></i>
                <span @click="goHome" style="cursor: pointer;">首页</span>
                <span>></span>
                <span>串讲视频</span>
            </div>
        </div>
        <div class="new-center-navigation clearfix">
            <h2 @click="toMetarial">教材中心</h2>
            <h2 class="activa">串讲视频</h2>
        </div>
        <div>
            <div class="clearfix ph-select-year-btn" @click="showComRankVisible = true">综合排序：
                <span v-if="orderNum == 1">发布时间</span>
                <span v-else>观看次数</span>
                <i class="el-icon-caret-bottom"></i></div>
            <div class="clearfix ph-select-year-btn" @click="showPhoneCerfity = true">证书类型：{{phoneSelectCertifyName}}<i class="el-icon-caret-bottom"></i></div>
        </div>
        <v-refresh :on-refresh="onRefresh">
            <v-reload :on-infinite-load="onInfiniteLoad" :parent-pull-up-state="infiniteLoadData.pullUpState">
                <ul class="ph-video-list-ul clearfix">
                    <li v-for="(item,index) in phVideoList" :key="index" class="clearfix v-list-item fl" @click="toVideoDetail(item.id)">
                        <div class="video-cover-con">
                            <img :src="item.docUrl+'?x-oss-process=video/snapshot,t_10000,f_jpg,w_329,h_160'" alt v-if="item.docUrl" />
                            <img :src="cover" alt v-else />
                            <div class="ph-video-time">{{item.docTimeLenght}}</div>
                        </div>
                        <div class="ph-video-intro-con">
                            <p class="p-v-title-con">{{item.videoTitle}}</p>
                            <div class="clearfix p-video-num">
                                <span class="fl">
                                    <i class="wl-icon-shijian"></i>
                                    {{item.dateCreated}}
                                </span>
                                <span class="fr">
                                    <i class="wl-icon-chakan"></i>
                                    {{item.viewCount}}
                                </span>
                            </div>
                        </div>
                    </li>
                </ul>
            </v-reload>
        </v-refresh>
    </div>
    <!-- 综合排序 -->
    <van-action-sheet v-model="showComRankVisible">
        <div class="ph-select-year-con">
            <div class="p-year-li van-hairline--bottom" @click="changeData(1)">发布时间</div>
            <div class="p-year-li van-hairline--bottom" @click="changeData(2)">观看次数</div>
        </div>
    </van-action-sheet>
    <!-- 移动端选择证书类型 -->
    <van-action-sheet v-model="showPhoneCerfity">
        <div class="ph-select-year-con">
            <div class="p-year-li van-hairline--bottom" v-for="item in certifycateList" :key="item.id" @click="changeCertifyType(item.id)">{{item.CertificateName}}</div>
        </div>
    </van-action-sheet>
</div>
</template>

<script>
import downFresh from "components/refreshData/downFresh.vue";
import pullUpReload from "components/refreshData/pullUpReload.vue";
export default {
    data() {
        return {
            imgs: 'https://file.clpp.org.cn/ykt/ori/dd6xaesrd5lfbwst9cqswg/AQcWHT6ENFCpTGMQ.png',
            nodataImg: require("assets/images/the-last-new-nodata-imag.png"),
            videoTitle: "",
            orderNum: 1,
            isTab: 1,
            type: 1,
            currentPage4: 1,
            videoList: [],
            page: 1,
            pageSize: 10,
            totalCount: 0,
            newsList: [],
            phDetailsData: [],
            infiniteLoadData: {
                initialShowNum: 3, // 初始显示多少条
                everyLoadingNum: 3, // 每次加载的个数
                pullUpState: 0, // 子组件的pullUpState状态
                pullUpList: [], // 上拉加载更多数据的数组
                showPullUpListLength: this.initialShowNum // 上拉加载后所展示的个数
            },
            index: "clppx",
            year: "",
            isBefor: "0",
            phBookData: [],
            booksInfoList: [],
            tabActiveIndex: 1,
            cover: "https://file.clpp.org.cn/66ykt/ori/dd6xaesrd5lfbwst9cqswg/74dGZ3WTwcPWShai.png",
            searchVideoName: "",
            phVideoList: [],
            videoTypeId: 1,
            videoTypeList: [],
            certifycateList: [],
            certifycateId: '',
            showPhoneCerfity: false,
            phoneSelectCertifyName: '',
            showComRankVisible: false
        };
    },
    components: {
        "v-refresh": downFresh,
        "v-reload": pullUpReload
    },
    props: {
        videoType: {
            type: [String, Number],
            default: ''
        }
    },
    created() {
        this.videoTypeId = this.videoType == "all" ? "" : this.videoType;
        this.getCerfitycateList();
        this.getVideoTypeAllList();

    },
    computed: {
        association: function () {
            return this.$store.state.association;
        }
    },
    methods: {
        changeCertifyType(id) {
            this.certifycateId = id;
            this.showPhoneCerfity = false;
            this.certifycateList.forEach(val => {
                if (val.id == this.certifycateId) {
                    this.phoneSelectCertifyName = val.CertificateName;
                }
            });
            this.getTeaVideoList(this.videoTypeId);
        },
        getCerfitycateList() {
            this.$http.post("/api/XOrg/AssociationIndex/getCertificateList").then(res => {
                if (res.code > 0) {
                    this.certifycateList = res.list;
                    if (this.certifycateList.length > 0) {
                        const [{
                            CertificateName,
                            id
                        }] = this.certifycateList;
                        this.certifycateId = id;
                        this.phoneSelectCertifyName = CertificateName;
                        this.getTeaVideoList(this.videoTypeId);
                    }
                }
            });
        },
        getVideoTypeAllList() {
            var that = this;
            that.$http
                .post("/api/XOrg/VideoType/getVideoTypeAllList", {})
                .then(rst => {
                    if (rst.code > 0) {
                        that.videoTypeList = rst.list;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        toVideoList(type) {
            this.videoTypeId = type;
            this.getTeaVideoList(type);
        },
        searchVideo() {
            this.videoTitle = this.searchVideoName;
            this.getTeaVideoList();
        },
        getTeaVideoList() {
            this.$http
                .post("/api/XOrg/VideoStudy/getTeaVideoList", {
                    videoTitle: this.videoTitle,
                    certificateId: this.certifycateId,
                    orderNum: this.orderNum,
                    videoTypeId: this.videoTypeId,
                    PageSize: this.pageSize,
                    page: this.page
                })
                .then(rst => {
                    if (rst.code > 0) {
                        this.videoList = rst.list;
                        this.page = rst.pagination.pageIndex;
                        this.pageSize = rst.pagination.pageSize;
                        this.totalCount = rst.pagination.totalCount;
                        this.phVideoList = rst.list;
                        if (this.phDetailsData.length == this.totalCount) {
                            this.infiniteLoadData.pullUpState = 3;
                        }
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });
        },
        changeData(type) {
            this.showComRankVisible = false;
            this.orderNum = type;
            this.getTeaVideoList();
        },
        toVideoDetail(id) {
            this.$router.push({
                name: 'videoDetail',
                params: {
                    videoId: id
                }
            });
        },
        toMetarial() {
            this.$router.push({
                name: "metarialCenter"
            });
        },
        onRefresh(done) {
            this.phVideoList = [];
            this.getTeaVideoList();
            done();
        },
        onInfiniteLoad(done) {
            this.pageSize += 4;
            this.getTeaVideoList();
            done();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getTeaVideoList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getTeaVideoList();
        },
        goHome() {
            this.$router.push({
                name: "xHome"
            });
        }
    }
};
</script>

<style lang="scss">
.wl-n-metarial-wrapper {
    .new-center-content {
        margin: 40px auto 0;
        width: 1200px;
    }

    .new-top-nav {
        width: 220px;
        height: 78px;
        padding: 21px 0px;
        background: #2d82ff;

        .new-top-title {
            font-size: 58px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #0155d1;
            margin-left: 23px;
            width: 48px;
        }

        .new-top-navtitle {
            padding-top: 16px;
            font-size: 18px;
            color: #fff;
        }

        .new-top-ews {
            padding-top: 8px;
            font-size: 14px;
            color: #0155d1;
            font-weight: bold;
        }
    }

    .new-center-tab {
        width: 220px;

        .new-center-dynamic {
            margin-top: 20px;
            font-size: 16px;
            height: 38px;
            background: #e9ebf0;
            line-height: 40px;
            cursor: pointer;
            padding: 0px 16px 0px 20px;
        }

        .link-child-li {
            color: black;
        }

        .class-back {
            background: #2d82ff;
            color: #fff;
        }

        .c-video-change-btn {
            margin-top: 0;
            border-top: 1px solid #fff;
            border-left: 2px solid #E9EBF0;
        }

        .class-back-item {
            color: #2d82ff;
            border-left-color: #2d82ff;
        }

        .wl-icon-xiangyou {
            height: 100%;
        }
    }

    .left-main-content {
        padding-bottom: 30px;
        margin-bottom: 40px;
        width: 950px;

        .new-center-listnav {
            margin-bottom: 30px;
            border-bottom: 2px solid #e9ebf0;
            height: 38px;
            line-height: 38px;

            h2 {
                font-size: 16px;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                width: 80px;
                height: 100%;
                border-bottom: 2px solid #2d82ff;
                float: left;
            }

            .new-center-path {
                float: right;

                .wl-icon-zhuye1 {
                    color: #a4a4a4;
                    font-size: 16px;
                }

                span {
                    margin-left: 7px;
                    font-size: 14px;
                    cursor: pointer;
                }
            }
        }
    }

    .cj-video-main-con {
        border: 1px solid #e9ebf0;
        border-top: none;

        .choose-publishBooks-time {
            padding: 10px 15px;
            border: 1px solid #e9ebf0;
        }

        .cerfitycate-type-con {
            border-top: none;
        }

        .change-year-btn {
            margin-right: 15px;
            padding: 7px 8px;
            border-radius: 2px;
            cursor: pointer;
        }

        .search-video-input {
            width: 240px;

            .el-icon-search {
                color: #2d82ff;
            }
        }

        .change-label {
            font-weight: bold;
        }

        .tabActive {
            background: #2d82ff;
            color: #fff;
        }

        .metarial-list-con {
            padding: 30px 20px;

            .video-list-item {
                margin-top: 20px; 
                margin-right: 20px;
                width: 289px;
                height: 268px;
                background: #e9ecf0;

                a {
                    display: block;
                    color: #505763;
                }
            }

            .video-list-item:nth-child(3n) {
                margin-right: 0;
            }

            .video-cover-con {
                position: relative;
                height: 170px;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: fill;
                }

                .video-time-con {
                    position: absolute;
                    right: 10px;
                    bottom: 10px;
                    z-index: 100;
                    background: rgba(0, 0, 0, 0.7);
                    color: #fff;
                    border-radius: 10px;
                    padding: 5px;
                    font-size: 12px;
                }
            }

            .video-intro-con {
                padding: 14px 15px;
            }

            .p-video-name {
                font-size: 16px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2; //行数
                -webkit-box-orient: vertical;
            }

            .video-time-con {
                margin-top: 12px;
                color: #505763;
                font-size: 14px;
            }

            .video-list-item:hover {
                background: #2d82ff;
                .video-intro-con {
                    color: #fff;

                    .video-time-con {
                        color: #fff;
                    }
                }
            }
        }
    }

    .ph-new-center-content {
        display: none;
        background: #fff;

        .crumbs-text {
            background: #f5f7fb;
            height: 40px;
            line-height: 40px;
            color: #666;

            span {
                margin: 0 3px;
            }
        }

        .new-center-navigation {
            height: 32px;
            line-height: 32px;
            margin-top: 10px;
            padding: 0px 20px;

            h2 {
                background: #e6e6e6;
                width: 90px;
                font-size: 14px;
                font-weight: normal;
                text-align: center;
                float: left;
            }

            .activa {
                background: #2d82ff;
                color: #fff;
            }
        }

        .ph-video-list-ul {
            padding: 0 20px 30px 20px;
            background: #fff;
        }

        .v-list-item {
            margin: 15px 4% 0 0;
            width: 48%;
        }

        .v-list-item:nth-child(2n) {
            margin-right: 0;
        }

        .video-cover-con {
            height: 100px;
            position: relative;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            .ph-video-time {
                position: absolute;
                right: 7px;
                bottom: 7px;
                z-index: 100;
                background: rgba(0, 0, 0, 0.7);
                color: #fff;
                border-radius: 10px;
                padding: 4px;
                font-size: 12px;
            }
        }

        .ph-video-intro-con {
            padding: 5px;
            font-size: 12px;
            background: #E9ECF0;

            .p-v-title-con {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .p-video-num {
                margin-top: 4px;
            }
        }
    }

    .ph-select-year-con {
        text-align: center;

        .p-year-li {
            height: 40px;
            line-height: 40px;
        }
    }
}

@media screen and (max-width: 980px) {
    .wl-n-metarial-wrapper {
        .new-center-content {
            display: none;
        }

        .ph-new-center-content {
            display: block;

            .ph-select-year-btn {
                padding-left: 20px;
                height: 36px;
                line-height: 36px;
            }
        }
    }
}
</style>
